import React from "react";
import { GlobalLoading } from "react-global-loading";
import LoadingSvg from "@/assets/imgs/icons/status/circle-loading.svg";
const loadingStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100%",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999
};
const CustomGlobalLoading = () => {
    return (
        <GlobalLoading WrapperComponent={() => <div style={loadingStyle}>
            <img alt="" style={{
                width: "80px"
            }} src={LoadingSvg} />
        </div>} />

    );
};

export default CustomGlobalLoading;